import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import { AppConstants } from '../../constants/AppConstants';
import AppActions from '../../app/app_actions';


const EnumImpostazioniActions = Object.freeze({
    LAST_SCHEMA_DATI: 'LAST_SCHEMA_DATI',
    IMPOSTAZIONI_SCHEMA_DATI: 'IMPOSTAZIONI_SCHEMA_DATI',
    IMPOSTAZIONI_PARAMETRI: ' IMPOSTAZIONI_PARAMETRI',
    INFO: 'IMPOSTAFIONI_INFO',
    IMPOSTAZIONI_I18N: 'IMPOSTAZIONI_I18N',
    IMPOSTAZIONI_I18N_DETAILS: 'IMPOSTAZIONI_I18N_DETAILS',
    NEWI18N: 'NEWI18N',
    IMPOSTAZIONI_HANDLE_CHANGE_CODICE: 'IMPOSTAZIONI_HANDLE_CHANGE_CODICE',
    UPDATE_I18N_LIST: 'UPDATE_I18N_LIST'
});

module.exports.EnumImpostazioniActions = EnumImpostazioniActions;


class ImpostazioniActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "ImpostazioniActions";
    }
    get Actions() {

        return EnumImpostazioniActions;
    }


    getInfo() {
        return function (dispatch) {
            return Rest.post('settings/getInfo', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumImpostazioniActions.INFO, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getLastSchemaDati() {
        return function (dispatch) {
            return Rest.post('settings/getLastSchemaDati', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumImpostazioniActions.LAST_SCHEMA_DATI, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getSchemaDati() {
        return function (dispatch) {
            return Rest.post('settings/getSchemaDati', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumImpostazioniActions.IMPOSTAZIONI_SCHEMA_DATI, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getParametriSistema() {
        return function (dispatch) {
            return Rest.post('settings/getParametri', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumImpostazioniActions.IMPOSTAZIONI_PARAMETRI, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }



};

export default ImpostazioniActions = new ImpostazioniActions;
